<script setup>
import { onMounted } from 'vue';

import ReportSectionCard from './ReportSectionCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';
import TeamTable from './overview/TeamTable.vue';

const store = useStore();

const uiFlags = useMapGetter('getOverviewUIFlags');
const teamConversationMetric = useMapGetter('getTeamConversationMetric');
const teams = useMapGetter('teams/getTeams');

const fetchData = () => store.dispatch('fetchTeamConversationMetric');

const { startRefetching } = useLiveRefresh(fetchData);

onMounted(() => {
  store.dispatch('teams/get');
  fetchData();
  startRefetching();
});
</script>

<template>
  <ReportSectionCard
    :title="$t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.HEADER')"
    :description="$t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.DESCRIPTION')"
    icon="i-hugeicons-user-group"
    live
    flush
  >
    <TeamTable
      :teams="teams"
      :team-metrics="teamConversationMetric"
      :is-loading="uiFlags.isFetchingTeamConversationMetric"
    />
  </ReportSectionCard>
</template>
